<app-module *ngIf="displayedChallenge">
  <div header class="header">
    <span *ngIf="displayedChallenge?.name">
      {{ displayedChallenge?.name }}
    </span>
    <span *ngIf="!displayedChallenge?.name"> {{ 'STATS.challenge.title' | translate }}</span>

    <div class="header-timeframe-container">
      <span class="header-timeframe-label">{{ 'STATS.challenge.challengeTimeframe' | translate }}</span>
      <span class="header-timeframe"> {{ displayedTimeframe }}</span>
    </div>
  </div>

  <app-next-challenge *ngIf="isFutureChallenge" [challenge]="displayedChallenge"> </app-next-challenge>
  <app-challenge-leaderboard *ngIf="!isFutureChallenge" [challenge]="displayedChallenge"> </app-challenge-leaderboard>
</app-module>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/challenge-statistics.component.html